import type { ReleasesFilters, TrackFilterUrlParamType } from './types';

export const TRACK_FILTER_URL_PARAMS = ['search', 'release', 'role'] as const;
export const TRACK_RELEASE_TYPE_OPTIONS = [
  'recent',
  'shallow',
  'deep',
] as const;

export const TRACK_ROLE_OPTIONS = ['main', 'featured'] as const;

export const FILTER_PARAMS: Record<
  keyof ReleasesFilters,
  TrackFilterUrlParamType
> = {
  searchText: 'search',
  releaseType: 'release',
  role: 'role',
} as const;

export const PERSIST_SEARCH_PARAMS = ['table_view'] as const;
